// extracted by mini-css-extract-plugin
export var cancelButton = "_nb-5";
export var content = "_nb-3";
export var createButton = "_nb-6";
export var drawerContainer = "_nb-0";
export var footer = "_nb-2";
export var header = "_nb-1";
export var orderFormColumn = "_nb-4";